module.exports = __webpack_public_path__ + "img/522.a60b20ac.jpg";